module.exports = __webpack_public_path__ + "3b8154272cb052e2e3ba68488c5b3a98.svg";